/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NotificacionesModelDto } from '../../models/notificaciones-model-dto';

export interface NotificacionesControllerObtenerNotificaciones$Params {
}

export function notificacionesControllerObtenerNotificaciones(http: HttpClient, rootUrl: string, params?: NotificacionesControllerObtenerNotificaciones$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NotificacionesModelDto>>> {
  const rb = new RequestBuilder(rootUrl, notificacionesControllerObtenerNotificaciones.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<NotificacionesModelDto>>;
    })
  );
}

notificacionesControllerObtenerNotificaciones.PATH = '/api/notificaciones/obtener-notificaciones';
